import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = {
  class: "dialog-footer"
};
import { ElMessage } from 'element-plus';
import { ref, watch } from 'vue';
import { getRoleList } from '@/api/role';
import { updateRole, userRoles } from '@/api/user';
export default {
  __name: 'roles',
  props: {
    modelValue: {
      type: Boolean,
      required: true
    },
    userId: {
      type: String,
      required: true
    }
  },
  emits: ['update:modelValue', 'updateRole'],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;

    /**
      确定按钮点击事件
     */
    const onConfirm = async () => {
      // 处理数据结构
      let roles = userRoleTitleList.value.map(name => {
        return allRoleList.value.find(role => role.name === name);
      });
      if (!roles.length) {
        roles = [{
          id: ''
        }];
      }
      try {
        await updateRole(props.userId, roles);
        ElMessage({
          message: '分配成功',
          type: 'success'
        });
        closed(); // 角色更新成功
        emits('updateRole');
      } catch (error) {
        // ElMessage({
        //   message: '分配失败',
        //   type: 'warning'
        // })
        closed(); // 角色更新成功
      }
    };

    /**
     * 关闭
     */
    const closed = () => {
      emits('update:modelValue', false);
    };

    // 所有角色
    const allRoleList = ref([]);
    // 获取所有角色数据的方法
    const getListData = async () => {
      const res = await getRoleList();
      allRoleList.value = res;
    };
    getListData();

    // 当前用户角色
    const userRoleTitleList = ref([]);

    // 获取当前用户角色
    const getUserRoles = async () => {
      const res = await userRoles(props.userId);
      userRoleTitleList.value = res.map(item => item.name);
    };
    watch(() => props.userId, val => {
      if (val) getUserRoles();
    });
    return (_ctx, _cache) => {
      const _component_el_checkbox = _resolveComponent("el-checkbox");
      const _component_el_checkbox_group = _resolveComponent("el-checkbox-group");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: "分配角色",
        "model-value": __props.modelValue,
        onClose: closed,
        "close-on-click-modal": false,
        class: "dialog-class"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_1, [_createVNode(_component_el_button, {
          onClick: closed
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: onConfirm
        }, {
          default: _withCtx(() => [_createTextVNode("确认")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createVNode(_component_el_checkbox_group, {
          modelValue: userRoleTitleList.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => userRoleTitleList.value = $event)
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allRoleList.value, item => {
            return _openBlock(), _createBlock(_component_el_checkbox, {
              key: item.id,
              label: item.name
            }, null, 8, ["label"]);
          }), 128))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }, 8, ["model-value"]);
    };
  }
};